import React from 'react';
import Heading from '../heading';

const Preview = (props) => {
  return (
    <div
      id="accessibility-widget"
      style={{ zIndex: "40" }}
    >
      <Heading
        title="Preview"
        text="This is a widget preview that will be visible to your site visitors."
        headingSize='base'
      />
      <div
        style={{
          justifyContent: "flex-start",
          alignItems: "center",
          display: "flex",
          marginTop: "15px"
        }}
      >
        <div
          className="accessibility-box"
          style={{ background: props.shop.settings.theme.branding }}
        >
          <div className="accessibility-box-heading">
            <p style={{ width: 240 }}>Accessibility options</p>
            {props.shop.settings.showHideForever && (
              <div className="accessibly-hide-btn">
                <p>Hide forever</p>
              </div>
            )}
            <a onClick={()=>console.log("alert")}>
              <svg
                className="accessibility-box-close"
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="#fff"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.53125 7.5L13.4375 11.4062C13.6719 11.6406 13.7891 11.9271 13.7891 12.2656C13.7891 12.6042 13.6719 12.9036 13.4375 13.1641L12.5781 14.0234C12.3177 14.2578 12.0182 14.375 11.6797 14.375C11.3411 14.375 11.0547 14.2578 10.8203 14.0234L6.91406 10.1172L3.00781 14.0234C2.77344 14.2578 2.48698 14.375 2.14844 14.375C1.8099 14.375 1.51042 14.2578 1.25 14.0234L0.390625 13.1641C0.15625 12.9036 0.0390625 12.6042 0.0390625 12.2656C0.0390625 11.9271 0.15625 11.6406 0.390625 11.4062L4.29688 7.5L0.390625 3.59375C0.15625 3.35938 0.0390625 3.07292 0.0390625 2.73438C0.0390625 2.39583 0.15625 2.09635 0.390625 1.83594L1.25 0.976562C1.51042 0.742188 1.8099 0.625 2.14844 0.625C2.48698 0.625 2.77344 0.742188 3.00781 0.976562L6.91406 4.88281L10.8203 0.976562C11.0547 0.742188 11.3411 0.625 11.6797 0.625C12.0182 0.625 12.3177 0.742188 12.5781 0.976562L13.4375 1.83594C13.6719 2.09635 13.7891 2.39583 13.7891 2.73438C13.7891 3.07292 13.6719 3.35938 13.4375 3.59375L9.53125 7.5Z"
                  fill="#FFF"
                />
              </svg>
            </a>
          </div>
          <div className="accessibility-options fixed-height">
            <div
              className="accessibility-row"
              style={{ maxHeight: "unset", height: "unset" }}
            >
              {props.shop.features.includes("bigger_text") && (
                <div className="accessibility-col">
                  <a
                    id="zoomIn"
                    style={{ fontSize: 16 }}
                    className="navigable"
                  >
                    <div>
                      <svg
                        className="option-svg"
                        width="30"
                        height="25"
                        viewBox="0 0 30 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.8125 12C17.8125 11.8242 17.6953 11.6484 17.5781 11.5312C17.4609 11.4141 17.2852 11.2969 17.1094 11.2969H13.8281V8.01562C13.8281 7.83984 13.7109 7.66406 13.5938 7.54688C13.4766 7.42969 13.3008 7.3125 13.125 7.3125H11.25C11.0156 7.3125 10.8398 7.42969 10.7227 7.54688C10.6055 7.66406 10.5469 7.83984 10.5469 8.01562V11.2969H7.26562C7.03125 11.2969 6.85547 11.4141 6.73828 11.5312C6.62109 11.6484 6.5625 11.8242 6.5625 12V13.875C6.5625 14.1094 6.62109 14.2852 6.73828 14.4023C6.85547 14.5195 7.03125 14.5781 7.26562 14.5781H10.5469V17.8594C10.5469 18.0938 10.6055 18.2695 10.7227 18.3867C10.8398 18.5039 11.0156 18.5625 11.25 18.5625H13.125C13.3008 18.5625 13.4766 18.5039 13.5938 18.3867C13.7109 18.2695 13.8281 18.0938 13.8281 17.8594V14.5781H17.1094C17.2852 14.5781 17.4609 14.5195 17.5781 14.4023C17.6953 14.2852 17.8125 14.1094 17.8125 13.875V12ZM29.5898 28.6992C29.8242 28.4648 30 28.1133 30 27.7031C30 27.3516 29.8242 27 29.5898 26.707L23.7305 20.8477C23.4375 20.6133 23.0859 20.4375 22.7344 20.4375H21.7969C23.4961 18.2695 24.375 15.75 24.375 12.9375C24.375 10.7109 23.7891 8.71875 22.7344 6.84375C21.6211 4.96875 20.1562 3.50391 18.2812 2.39062C16.4062 1.33594 14.4141 0.75 12.1875 0.75C9.96094 0.75 7.91016 1.33594 6.03516 2.39062C4.16016 3.50391 2.69531 4.96875 1.64062 6.84375C0.527344 8.71875 0 10.7109 0 12.9375C0 15.1641 0.527344 17.2148 1.64062 19.0898C2.69531 20.9648 4.16016 22.4297 6.03516 23.4844C7.91016 24.5977 9.96094 25.125 12.1875 25.125C15 25.125 17.4609 24.3047 19.6875 22.5469V23.4844C19.6875 23.8945 19.8047 24.2461 20.0977 24.4805L25.957 30.3398C26.1914 30.6328 26.543 30.75 26.9531 30.75C27.3047 30.75 27.6562 30.6328 27.9492 30.3398L29.5898 28.6992ZM20.1562 12.9375C20.1562 14.4023 19.7461 15.75 19.043 16.9219C18.3398 18.1523 17.3438 19.1484 16.1719 19.8516C14.9414 20.5547 13.5938 20.9062 12.1875 20.9062C10.7227 20.9062 9.375 20.5547 8.20312 19.8516C6.97266 19.1484 5.97656 18.1523 5.27344 16.9219C4.57031 15.75 4.21875 14.4023 4.21875 12.9375C4.21875 11.5312 4.57031 10.1836 5.27344 8.95312C5.97656 7.78125 6.97266 6.78516 8.20312 6.08203C9.375 5.37891 10.7227 4.96875 12.1875 4.96875C13.5938 4.96875 14.9414 5.37891 16.1719 6.08203C17.3438 6.78516 18.3398 7.78125 19.043 8.95312C19.7461 10.1836 20.1562 11.5312 20.1562 12.9375Z"
                          fill="#D0D0D0"
                        />
                      </svg>
                      <div data-translation="zoom" className="center-text">
                        Bigger Text
                      </div>
                      <div className="accessibility-box-lines">
                        <svg
                          width="20"
                          height="6"
                          style={{ width: 20, height: 6 }}
                          viewBox="0 0 20 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            data-border="1"
                            width="20"
                            height="6"
                            rx="3"
                            fill="#D0D0D0"
                          />
                        </svg>
                        <svg
                          width="20"
                          height="6"
                          style={{ width: 20, height: 6 }}
                          viewBox="0 0 20 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            data-border="2"
                            width="20"
                            height="6"
                            rx="3"
                            fill="#D0D0D0"
                          />
                        </svg>
                        <svg
                          width="20"
                          height="6"
                          style={{ width: 20, height: 6 }}
                          viewBox="0 0 20 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            data-border="3"
                            width="20"
                            height="6"
                            rx="3"
                            fill="#D0D0D0"
                          />
                        </svg>
                      </div>
                    </div>
                  </a>
                </div>
              )}
              {props.shop.features.includes("bigger_cursor") && (
                <div className="accessibility-col mobile-accessibly-d-none">
                  <a
                    id="cursor"
                    style={{ fontSize: 16 }}
                    className="navigable"
                  >
                    <div>
                      <svg
                        className="option-svg"
                        width="20"
                        height="25"
                        viewBox="0 0 20 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.3203 20.0273H12.1094L15.3906 27.9961C15.5078 28.2695 15.5078 28.543 15.3906 28.8164C15.2734 29.0898 15.0781 29.2852 14.8047 29.4023L11.9336 30.6914C11.6602 30.7695 11.3867 30.75 11.1133 30.6328C10.8789 30.5547 10.7031 30.3789 10.5859 30.1055L7.48047 22.5469L2.38281 27.7617C2.07031 28.1133 1.69922 28.1914 1.26953 27.9961C0.839844 27.8008 0.625 27.4688 0.625 27V1.80469C0.625 1.33594 0.839844 1.02344 1.26953 0.867188C1.73828 0.671875 2.10938 0.730469 2.38281 1.04297L19.082 18.2109C19.3945 18.5234 19.4531 18.9141 19.2578 19.3828C19.1016 19.8125 18.7891 20.0273 18.3203 20.0273Z"
                          fill="#D0D0D0"
                        />
                      </svg>
                      <div data-translation="cursor" className="center-text">
                        Bigger Cursor
                      </div>
                    </div>
                  </a>
                </div>
              )}
              {props.shop.features.includes("invert_colors") && (
                <div className="accessibility-col">
                  <a
                    id="invert"
                    style={{ fontSize: 16 }}
                    className="navigable"
                  >
                    <div>
                      <svg
                        className="option-svg"
                        width="34"
                        height="23"
                        viewBox="0 0 34 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.625 0.5C25.75 0.5 28.4062 1.59375 30.5938 3.78125C32.7812 5.96875 33.875 8.625 33.875 11.75C33.875 14.875 32.7812 17.5312 30.5938 19.7188C28.4062 21.9062 25.75 23 22.625 23H11.375C8.25 23 5.59375 21.9062 3.40625 19.7188C1.21875 17.5312 0.125 14.875 0.125 11.75C0.125 8.625 1.21875 5.96875 3.40625 3.78125C5.59375 1.59375 8.25 0.5 11.375 0.5H22.625ZM6.04297 6.47656C4.59766 7.92188 3.875 9.67969 3.875 11.75C3.875 13.8203 4.59766 15.5977 6.04297 17.082C7.52734 18.5273 9.30469 19.25 11.375 19.25C13.4453 19.25 15.2031 18.5273 16.6484 17.082C18.1328 15.5977 18.875 13.8203 18.875 11.75C18.875 9.67969 18.1328 7.92188 16.6484 6.47656C15.2031 4.99219 13.4453 4.25 11.375 4.25C9.30469 4.25 7.52734 4.99219 6.04297 6.47656ZM22.625 19.25C24.6953 19.25 26.4531 18.5273 27.8984 17.082C29.3828 15.5977 30.125 13.8203 30.125 11.75C30.125 9.67969 29.3828 7.92188 27.8984 6.47656C26.4531 4.99219 24.6953 4.25 22.625 4.25H19.7539C21.668 6.39844 22.625 8.89844 22.625 11.75C22.625 14.6016 21.668 17.1016 19.7539 19.25H22.625Z"
                          fill="#D0D0D0"
                        />
                      </svg>
                      <div data-translation="invert" className="center-text">
                        Invert Colors
                      </div>
                    </div>
                  </a>
                </div>
              )}
              {props.shop.features.includes("contrast") && (
                <div className="accessibility-col">
                  <a
                    id="contrast"
                    style={{ fontSize: 16 }}
                    className="navigable"
                  >
                    <div>
                      <svg
                        className="option-svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.6875 25.0625C1.875 22.2109 0.46875 18.7734 0.46875 14.75C0.46875 10.7266 1.875 7.30859 4.6875 4.49609C7.53906 1.64453 10.9766 0.21875 15 0.21875C19.0234 0.21875 22.4414 1.64453 25.2539 4.49609C28.1055 7.30859 29.5312 10.7266 29.5312 14.75C29.5312 18.7734 28.1055 22.2109 25.2539 25.0625C22.4414 27.875 19.0234 29.2812 15 29.2812C10.9766 29.2812 7.53906 27.875 4.6875 25.0625ZM15 25.5312C17.9688 25.5312 20.5078 24.4766 22.6172 22.3672C24.7266 20.2578 25.7812 17.7188 25.7812 14.75C25.7812 11.7812 24.7266 9.24219 22.6172 7.13281C20.5078 5.02344 17.9688 3.96875 15 3.96875V25.5312Z"
                          fill="#D0D0D0"
                        />
                      </svg>
                      <div
                        data-translation="contrast"
                        className="center-text"
                      >
                        Contrast
                      </div>
                      <div className="accessibility-box-lines">
                        <svg
                          width="20"
                          height="6"
                          style={{ width: 20, height: 6 }}
                          viewBox="0 0 20 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="20"
                            data-border="1"
                            height="6"
                            rx="3"
                            fill="#D0D0D0"
                          />
                        </svg>
                        <svg
                          width="20"
                          height="6"
                          style={{ width: 20, height: 6 }}
                          viewBox="0 0 20 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="20"
                            data-border="2"
                            height="6"
                            rx="3"
                            fill="#D0D0D0"
                          />
                        </svg>
                      </div>
                    </div>
                  </a>
                </div>
              )}
              {props.shop.features.includes("brightness") && (
                <div className="accessibility-col">
                  <a
                    id="brightness"
                    style={{ fontSize: 16 }}
                    className="navigable"
                  >
                    <div>
                      <svg
                        className="option-svg"
                        width="31"
                        height="25"
                        viewBox="0 0 31 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.0742 11.7656C12.168 10.6719 13.4961 10.125 15.0586 10.125C16.6211 10.125 17.9492 10.6719 19.043 11.7656C20.1367 12.8594 20.6836 14.1875 20.6836 15.75C20.6836 17.3125 20.1367 18.6406 19.043 19.7344C17.9492 20.8281 16.6211 21.375 15.0586 21.375C13.4961 21.375 12.168 20.8281 11.0742 19.7344C9.98047 18.6406 9.43359 17.3125 9.43359 15.75C9.43359 14.1875 9.98047 12.8594 11.0742 11.7656ZM29.4727 14.8125C29.8633 15.0078 30.0586 15.3203 30.0586 15.75C30.0586 16.1797 29.8633 16.4922 29.4727 16.6875L23.9648 19.4414L25.8984 25.3008C26.0156 25.6914 25.918 26.043 25.6055 26.3555C25.332 26.668 25 26.7461 24.6094 26.5898L18.75 24.6562L15.9375 30.1641C15.7812 30.5547 15.4883 30.75 15.0586 30.75C14.6289 30.75 14.3164 30.5547 14.1211 30.1641L11.3672 24.6562L5.50781 26.5898C5.11719 26.7461 4.76562 26.6875 4.45312 26.4141C4.14062 26.1016 4.0625 25.7305 4.21875 25.3008L6.15234 19.4414L0.644531 16.6875C0.253906 16.4922 0.0585938 16.1797 0.0585938 15.75C0.0585938 15.3203 0.253906 15.0078 0.644531 14.8125L6.15234 12.0586L4.21875 6.19922C4.0625 5.80859 4.12109 5.45703 4.39453 5.14453C4.70703 4.83203 5.07812 4.75391 5.50781 4.91016L11.3672 6.84375L14.1211 1.33594C14.3164 0.945312 14.6289 0.75 15.0586 0.75C15.4883 0.75 15.8008 0.945312 15.9961 1.33594L18.75 6.84375L24.6094 4.91016C25 4.75391 25.3516 4.83203 25.6641 5.14453C25.9766 5.45703 26.0547 5.80859 25.8984 6.19922L23.9648 12.0586L29.4727 14.8125ZM15.0586 23.25C17.1289 23.25 18.8867 22.5273 20.332 21.082C21.8164 19.5977 22.5586 17.8203 22.5586 15.75C22.5586 13.6797 21.8164 11.9219 20.332 10.4766C18.8867 8.99219 17.1289 8.25 15.0586 8.25C12.9883 8.25 11.2109 8.99219 9.72656 10.4766C8.28125 11.9219 7.55859 13.6797 7.55859 15.75C7.55859 17.8203 8.28125 19.5977 9.72656 21.082C11.2109 22.5273 12.9883 23.25 15.0586 23.25Z"
                          fill="#D0D0D0"
                        />
                      </svg>
                      <div
                        data-translation="brightness"
                        className="center-text"
                      >
                        Brightness
                      </div>
                      <div className="accessibility-box-lines">
                        <svg
                          width="20"
                          height="6"
                          style={{ width: 20, height: 6 }}
                          viewBox="0 0 20 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="20"
                            data-border="1"
                            height="6"
                            rx="3"
                            fill="#D0D0D0"
                          />
                        </svg>
                        <svg
                          width="20"
                          height="6"
                          style={{ width: 20, height: 6 }}
                          viewBox="0 0 20 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="20"
                            data-border="2"
                            height="6"
                            rx="3"
                            fill="#D0D0D0"
                          />
                        </svg>
                      </div>
                    </div>
                  </a>
                </div>
              )}
              {props.shop.features.includes("grayscale") && (
                <div className="accessibility-col">
                  <a
                    id="grayscale"
                    style={{ fontSize: 16 }}
                    className="navigable"
                  >
                    <div>
                      <svg
                        className="option-svg"
                        width="22"
                        height="25"
                        viewBox="0 0 22 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.6992 2.03906C13.3242 4.07031 14.1641 6.02344 15.2188 7.89844C16.2734 9.73437 17.2305 11.1797 18.0898 12.2344C18.9492 13.2891 19.6914 14.5391 20.3164 15.9844C20.9805 17.3906 21.3125 18.8359 21.3125 20.3203C21.3125 23.2109 20.2969 25.6719 18.2656 27.7031C16.2734 29.7344 13.8516 30.75 11 30.75C8.14844 30.75 5.70703 29.7344 3.67578 27.7031C1.68359 25.6719 0.6875 23.2109 0.6875 20.3203C0.6875 18.8359 1 17.3906 1.625 15.9844C2.28906 14.5781 3.05078 13.3281 3.91016 12.2344C4.80859 11.1406 5.76562 9.67578 6.78125 7.83984C7.83594 6.00391 8.67578 4.07031 9.30078 2.03906C9.57422 1.17969 10.1406 0.75 11 0.75C11.8984 0.75 12.4648 1.17969 12.6992 2.03906ZM11 27C11.2734 27 11.4883 26.9219 11.6445 26.7656C11.8398 26.5703 11.9375 26.3359 11.9375 26.0625C11.9375 25.7891 11.8398 25.5742 11.6445 25.418C11.4883 25.2227 11.2734 25.125 11 25.125C9.71094 25.125 8.59766 24.6758 7.66016 23.7773C6.76172 22.8398 6.3125 21.7266 6.3125 20.4375C6.3125 20.1641 6.21484 19.9492 6.01953 19.793C5.86328 19.5977 5.64844 19.5 5.375 19.5C5.10156 19.5 4.86719 19.5977 4.67188 19.793C4.51562 19.9492 4.4375 20.1641 4.4375 20.4375C4.4375 22.2344 5.08203 23.7773 6.37109 25.0664C7.66016 26.3555 9.20312 27 11 27Z"
                          fill="#D0D0D0"
                        />
                      </svg>
                      <div
                        data-translation="grayscale"
                        className="center-text"
                      >
                        Grayscale
                      </div>
                    </div>
                  </a>
                </div>
              )}
              {props.shop.features.includes("reading_line") && (
                <div className="accessibility-col mobile-accessibly-d-none">
                  <a
                    id="readingLine"
                    style={{ fontSize: 16 }}
                    className="navigable"
                  >
                    <div>
                      <svg
                        className="option-svg"
                        width="24"
                        height="25"
                        viewBox="0 0 24 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.875 8.71875C13.875 9.10938 14.0117 9.44141 14.2852 9.71484C14.5586 9.98828 14.8906 10.125 15.2812 10.125H23.25V29.3438C23.25 29.7344 23.1133 30.0664 22.8398 30.3398C22.5664 30.6133 22.2344 30.75 21.8438 30.75H2.15625C1.76562 30.75 1.43359 30.6133 1.16016 30.3398C0.886719 30.0664 0.75 29.7344 0.75 29.3438V2.15625C0.75 1.76562 0.886719 1.43359 1.16016 1.16016C1.43359 0.886719 1.76562 0.75 2.15625 0.75H13.875V8.71875ZM17.625 22.5469V22.0781C17.625 21.6094 17.3906 21.375 16.9219 21.375H7.07812C6.60938 21.375 6.375 21.6094 6.375 22.0781V22.5469C6.375 23.0156 6.60938 23.25 7.07812 23.25H16.9219C17.3906 23.25 17.625 23.0156 17.625 22.5469ZM17.625 18.7969V18.3281C17.625 17.8594 17.3906 17.625 16.9219 17.625H7.07812C6.60938 17.625 6.375 17.8594 6.375 18.3281V18.7969C6.375 19.2656 6.60938 19.5 7.07812 19.5H16.9219C17.3906 19.5 17.625 19.2656 17.625 18.7969ZM17.625 14.5781C17.625 14.1094 17.3906 13.875 16.9219 13.875H7.07812C6.60938 13.875 6.375 14.1094 6.375 14.5781V15.0469C6.375 15.5156 6.60938 15.75 7.07812 15.75H16.9219C17.3906 15.75 17.625 15.5156 17.625 15.0469V14.5781ZM23.25 7.89844V8.25H15.75V0.75H16.1016C16.4922 0.75 16.8242 0.886719 17.0977 1.16016L22.8398 6.90234C23.1133 7.17578 23.25 7.50781 23.25 7.89844Z"
                          fill="#D0D0D0"
                        />
                      </svg>
                      <div
                        data-translation="reading-line"
                        className="center-text"
                      >
                        Reading Line
                      </div>
                    </div>
                  </a>
                </div>
              )}
              {props.shop.features.includes("readable_fonts") && (
                <div className="accessibility-col">
                  <a
                    id="fonts"
                    style={{ fontSize: 16 }}
                    className="navigable"
                  >
                    <div>
                      <svg
                        className="option-svg"
                        width="28"
                        height="25"
                        viewBox="0 0 28 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M26.1875 23.125C26.4609 23.125 26.6758 23.2227 26.832 23.418C27.0273 23.5742 27.125 23.7891 27.125 24.0625V25.9375C27.125 26.2109 27.0273 26.4258 26.832 26.582C26.6758 26.7773 26.4609 26.875 26.1875 26.875H18.6875C18.4141 26.875 18.1797 26.7773 17.9844 26.582C17.8281 26.4258 17.75 26.2109 17.75 25.9375V24.0625C17.75 23.7891 17.8281 23.5742 17.9844 23.418C18.1797 23.2227 18.4141 23.125 18.6875 23.125H19.8594L18.4531 19.375H9.54688L8.14062 23.125H9.3125C9.58594 23.125 9.80078 23.2227 9.95703 23.418C10.1523 23.5742 10.25 23.7891 10.25 24.0625V25.9375C10.25 26.2109 10.1523 26.4258 9.95703 26.582C9.80078 26.7773 9.58594 26.875 9.3125 26.875H1.8125C1.53906 26.875 1.30469 26.7773 1.10938 26.582C0.953125 26.4258 0.875 26.2109 0.875 25.9375V24.0625C0.875 23.7891 0.953125 23.5742 1.10938 23.418C1.30469 23.2227 1.53906 23.125 1.8125 23.125H3.16016L10.8359 1.91406C10.9531 1.5625 11.1875 1.26953 11.5391 1.03516C11.8906 0.761719 12.2422 0.625 12.5938 0.625H15.4062C15.7578 0.625 16.1094 0.761719 16.4609 1.03516C16.8125 1.26953 17.0469 1.5625 17.1641 1.91406L24.8398 23.125H26.1875ZM11.2461 14.6875H16.7539L14 7.12891L11.2461 14.6875Z"
                          fill="#D0D0D0"
                        />
                      </svg>
                      <div data-translation="fonts" className="center-text">
                        Readable fonts
                      </div>
                    </div>
                  </a>
                </div>
              )}
              {props.shop.features.includes("tooltips") && (
                <div className="accessibility-col mobile-accessibly-d-none">
                  <a
                    id="tooltips"
                    style={{ fontSize: 16 }}
                    className="navigable"
                  >
                    <div>
                      <svg
                        className="option-svg"
                        width="31"
                        height="30"
                        viewBox="0 0 31 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.45312 4.19922C7.38281 1.81641 10.918 0.625 15.0586 0.625C19.1992 0.625 22.7344 1.81641 25.6641 4.19922C28.5938 6.58203 30.0586 9.45312 30.0586 12.8125C30.0586 16.1719 28.5938 19.043 25.6641 21.4258C22.7344 23.8086 19.1992 25 15.0586 25C12.8711 25 10.7812 24.6289 8.78906 23.8867C6.25 25.8789 3.49609 26.875 0.527344 26.875C0.449219 26.875 0.371094 26.8359 0.292969 26.7578C0.214844 26.7188 0.15625 26.6602 0.117188 26.582C0.0390625 26.3867 0.0585938 26.2109 0.175781 26.0547C0.332031 25.9375 0.566406 25.6641 0.878906 25.2344C1.23047 24.8438 1.67969 24.1797 2.22656 23.2422C2.77344 22.2656 3.16406 21.3477 3.39844 20.4883C1.17188 18.2617 0.0585938 15.7031 0.0585938 12.8125C0.0585938 9.45312 1.52344 6.58203 4.45312 4.19922Z"
                          fill="#D0D0D0"
                        />
                      </svg>
                      <div
                        data-translation="tooltips"
                        className="center-text"
                      >
                        Tooltips
                      </div>
                    </div>
                  </a>
                </div>
              )}
              {props.shop.features.includes("highlight_links") && (
                <div className="accessibility-col">
                  <a
                    id="links"
                    style={{ fontSize: 16 }}
                    className="navigable"
                  >
                    <div>
                      <svg
                        className="option-svg"
                        width="31"
                        height="25"
                        viewBox="0 0 31 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.2188 11.5898C20.9375 13.3477 21.7969 15.457 21.7969 17.918C21.7969 20.3789 20.9375 22.4688 19.2188 24.1875L15.2344 28.1719C13.5156 29.8906 11.4258 30.75 8.96484 30.75C6.50391 30.75 4.39453 29.8711 2.63672 28.1133C0.917969 26.3945 0.0585938 24.3047 0.0585938 21.8438C0.0585938 19.3828 0.917969 17.293 2.63672 15.5742L4.86328 13.3477C5.13672 13.0742 5.44922 13.0156 5.80078 13.1719C6.19141 13.3281 6.40625 13.6016 6.44531 13.9922C6.48438 15.0469 6.67969 16.082 7.03125 17.0977C7.14844 17.4492 7.07031 17.7617 6.79688 18.0352L6.03516 18.8555C5.21484 19.6758 4.78516 20.6719 4.74609 21.8438C4.74609 22.9766 5.15625 23.9531 5.97656 24.7734C6.79688 25.6328 7.79297 26.0625 8.96484 26.0625C10.1367 26.0625 11.1328 25.6523 11.9531 24.832L15.8789 20.9062C16.6992 20.0859 17.1094 19.0898 17.1094 17.918C17.1094 16.7461 16.6992 15.75 15.8789 14.9297C15.6836 14.7344 15.4883 14.5586 15.293 14.4023C15.0195 14.2461 14.8828 14.0117 14.8828 13.6992C14.8438 12.9961 15.0586 12.4102 15.5273 11.9414L16.8164 10.7109C17.168 10.3203 17.5586 10.2813 17.9883 10.5938C18.418 10.9062 18.8281 11.2383 19.2188 11.5898ZM21.1523 0.75C23.6133 0.75 25.7031 1.62891 27.4219 3.38672C29.1797 5.10547 30.0586 7.19531 30.0586 9.65625C30.0586 12.1172 29.1992 14.207 27.4805 15.9258L25.2539 18.1523C24.9805 18.4258 24.6484 18.4844 24.2578 18.3281C23.9062 18.1719 23.7109 17.8984 23.6719 17.5078C23.6328 16.4531 23.4375 15.418 23.0859 14.4023C22.9688 14.0508 23.0469 13.7383 23.3203 13.4648L24.082 12.6445C24.9023 11.8242 25.3125 10.8477 25.3125 9.71484C25.3516 8.54297 24.9609 7.54688 24.1406 6.72656C23.3203 5.86719 22.3242 5.4375 21.1523 5.4375C19.9805 5.4375 18.9844 5.84766 18.1641 6.66797L14.2383 10.5938C13.418 11.4141 13.0078 12.4102 13.0078 13.582C13.0078 14.7539 13.418 15.75 14.2383 16.5703C14.4336 16.7656 14.6289 16.9414 14.8242 17.0977C15.0977 17.2539 15.2344 17.4883 15.2344 17.8008C15.2734 18.5039 15.0586 19.0898 14.5898 19.5586L13.3008 20.7891C12.9492 21.1797 12.5586 21.2188 12.1289 20.9062C11.6992 20.5938 11.2891 20.2617 10.8984 19.9102C9.17969 18.1523 8.32031 16.043 8.32031 13.582C8.32031 11.1211 9.17969 9.03125 10.8984 7.3125L14.8828 3.32812C16.6016 1.60938 18.6914 0.75 21.1523 0.75Z"
                          fill="#D0D0D0"
                        />
                      </svg>
                      <div data-translation="links" className="center-text">
                        Highlight Links
                      </div>
                    </div>
                  </a>
                </div>
              )}
              {props.shop.features.includes("hide_images") && (
                <div className="accessibility-col">
                  <a id="hide-images" className="navigable">
                    <div>
                      <svg
                        className="option-svg"
                        width="29"
                        height="25"
                        viewBox="0 0 34 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M28.25 23.125V24.0625C28.25 24.8438 27.9766 25.5078 27.4297 26.0547C26.8828 26.6016 26.2188 26.875 25.4375 26.875H2.9375C2.15625 26.875 1.49219 26.6016 0.945312 26.0547C0.398438 25.5078 0.125 24.8438 0.125 24.0625V9.0625C0.125 8.28125 0.398438 7.61719 0.945312 7.07031C1.49219 6.52344 2.15625 6.25 2.9375 6.25H3.875V18.4375C3.875 19.7266 4.32422 20.8398 5.22266 21.7773C6.16016 22.6758 7.27344 23.125 8.5625 23.125H28.25ZM33.875 18.4375C33.875 19.2188 33.6016 19.8828 33.0547 20.4297C32.5078 20.9766 31.8438 21.25 31.0625 21.25H8.5625C7.78125 21.25 7.11719 20.9766 6.57031 20.4297C6.02344 19.8828 5.75 19.2188 5.75 18.4375V3.4375C5.75 2.65625 6.02344 1.99219 6.57031 1.44531C7.11719 0.898438 7.78125 0.625 8.5625 0.625H31.0625C31.8438 0.625 32.5078 0.898438 33.0547 1.44531C33.6016 1.99219 33.875 2.65625 33.875 3.4375V18.4375ZM14.3047 8.24219C14.8516 7.69531 15.125 7.03125 15.125 6.25C15.125 5.46875 14.8516 4.80469 14.3047 4.25781C13.7578 3.71094 13.0938 3.4375 12.3125 3.4375C11.5312 3.4375 10.8672 3.71094 10.3203 4.25781C9.77344 4.80469 9.5 5.46875 9.5 6.25C9.5 7.03125 9.77344 7.69531 10.3203 8.24219C10.8672 8.78906 11.5312 9.0625 12.3125 9.0625C13.0938 9.0625 13.7578 8.78906 14.3047 8.24219ZM9.5 14.6875V17.5H30.125V10.9375L24.9688 5.78125C24.6562 5.46875 24.3438 5.46875 24.0312 5.78125L16.0625 13.75L13.7188 11.4062C13.4062 11.0938 13.0938 11.0938 12.7812 11.4062L9.5 14.6875Z"
                          fill="#D0D0D0"
                        />
                      </svg>
                      <div
                        data-translation="hide-images"
                        className="center-text"
                      >
                        Hide images
                      </div>
                    </div>
                  </a>
                </div>
              )}
              {props.shop.features.includes("read_page") && (
                <div className="accessibility-col">
                  <a id="voice" className="navigable">
                    <div>
                      <svg
                        className="option-svg"
                        width="34"
                        height="25"
                        viewBox="0 0 34 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.7227 3.91016C13.1523 3.48047 13.6602 3.38281 14.2461 3.61719C14.832 3.85156 15.125 4.28125 15.125 4.90625V24.5938C15.125 25.2188 14.832 25.6484 14.2461 25.8828C13.6602 26.1172 13.1523 26.0195 12.7227 25.5898L7.50781 20.375H1.53125C1.14062 20.375 0.808594 20.2383 0.535156 19.9648C0.261719 19.6914 0.125 19.3594 0.125 18.9688V10.5312C0.125 10.1406 0.261719 9.80859 0.535156 9.53516C0.808594 9.26172 1.14062 9.125 1.53125 9.125H7.50781L12.7227 3.91016ZM26.375 0.921875C28.7188 2.44531 30.5547 4.4375 31.8828 6.89844C33.2109 9.35938 33.875 11.9766 33.875 14.75C33.875 17.5234 33.2109 20.1406 31.8828 22.6016C30.5547 25.0625 28.7188 27.0547 26.375 28.5781C26.0625 28.8125 25.7109 28.8711 25.3203 28.7539C24.9297 28.6758 24.6172 28.4805 24.3828 28.168C24.1875 27.8555 24.1289 27.5039 24.207 27.1133C24.2852 26.7227 24.5 26.4297 24.8516 26.2344C26.1406 25.375 27.2344 24.3594 28.1328 23.1875C29.0703 21.9766 29.793 20.6484 30.3008 19.2031C30.8086 17.7578 31.0625 16.2734 31.0625 14.75C31.0625 12.4453 30.4961 10.2773 29.3633 8.24609C28.2695 6.21484 26.7656 4.55469 24.8516 3.26562C24.5 3.07031 24.2852 2.77734 24.207 2.38672C24.1289 1.99609 24.1875 1.64453 24.3828 1.33203C24.6172 1.01953 24.9297 0.824219 25.3203 0.746094C25.7109 0.628906 26.0625 0.6875 26.375 0.921875ZM26.9023 9.53516C27.8008 11.1367 28.25 12.875 28.25 14.75C28.25 16.625 27.8008 18.3828 26.9023 20.0234C26.043 21.625 24.8125 22.9141 23.2109 23.8906C22.8594 24.125 22.4883 24.2031 22.0977 24.125C21.7461 24.0078 21.4727 23.793 21.2773 23.4805C21.082 23.1289 21.0234 22.7773 21.1016 22.4258C21.1797 22.0352 21.3945 21.7227 21.7461 21.4883C22.4883 21.0195 23.1328 20.4336 23.6797 19.7305C24.2656 19.0273 24.6953 18.2461 24.9688 17.3867C25.2812 16.5273 25.4375 15.6484 25.4375 14.75C25.4375 13.8516 25.2812 12.9727 24.9688 12.1133C24.6953 11.2539 24.2656 10.4727 23.6797 9.76953C23.1328 9.06641 22.4883 8.48047 21.7461 8.01172C21.3945 7.77734 21.1797 7.48438 21.1016 7.13281C21.0234 6.74219 21.082 6.39062 21.2773 6.07812C21.4727 5.72656 21.7656 5.51172 22.1562 5.43359C22.5469 5.31641 22.8984 5.375 23.2109 5.60938C24.8125 6.58594 26.043 7.89453 26.9023 9.53516ZM19.9297 10.2383C20.75 10.707 21.3945 11.3516 21.8633 12.1719C22.3711 12.9531 22.625 13.8125 22.625 14.75C22.625 15.6875 22.3711 16.5664 21.8633 17.3867C21.3945 18.168 20.75 18.793 19.9297 19.2617C19.6172 19.457 19.2656 19.4961 18.875 19.3789C18.4844 19.2617 18.1914 19.0469 17.9961 18.7344C17.8398 18.3828 17.8008 18.0312 17.8789 17.6797C17.9961 17.2891 18.2305 16.9961 18.582 16.8008C19.4023 16.332 19.8125 15.6484 19.8125 14.75C19.8125 13.8516 19.4023 13.168 18.582 12.6992C18.2305 12.5039 17.9961 12.2305 17.8789 11.8789C17.8008 11.4883 17.8398 11.1367 17.9961 10.8242C18.1914 10.4727 18.4844 10.2383 18.875 10.1211C19.2656 10.0039 19.6172 10.043 19.9297 10.2383Z"
                          fill="#D0D0D0"
                        />
                      </svg>
                      <div data-translation="voice" className="center-text">
                        Read page
                      </div>
                    </div>
                  </a>
                </div>
              )}
              <div className="accessibility-col-mobile accessibly-mobile-visible reset-settings-col">
                <a id="reset-mobile" className="navigable">
                  <div>
                    <svg
                      className="option-svg"
                      width="18"
                      height="25"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.45312 8.125H0.421875C0.304688 8.125 0.199219 8.08984 0.105469 8.01953C0.0351562 7.92578 0 7.82031 0 7.70312V0.671875C0 0.390625 0.140625 0.25 0.421875 0.25H2.10938C2.39062 0.25 2.53125 0.390625 2.53125 0.671875V3.41406C3.35156 2.5 4.32422 1.79688 5.44922 1.30469C6.59766 0.789062 7.80469 0.53125 9.07031 0.53125C11.4844 0.554688 13.5352 1.42187 15.2227 3.13281C16.9102 4.82031 17.7422 6.87109 17.7188 9.28516C17.7188 11.6758 16.8633 13.7266 15.1523 15.4375C13.4648 17.125 11.4141 17.9688 9 17.9688C6.77344 17.9688 4.82812 17.2188 3.16406 15.7188C2.92969 15.5078 2.91797 15.2969 3.12891 15.0859L4.32422 13.8906C4.51172 13.7031 4.71094 13.7031 4.92188 13.8906C6.09375 14.9219 7.45312 15.4375 9 15.4375C10.7109 15.4375 12.1641 14.8398 13.3594 13.6445C14.5781 12.4258 15.1875 10.9609 15.1875 9.25C15.1875 7.53906 14.5781 6.08594 13.3594 4.89062C12.1641 3.67187 10.7109 3.0625 9 3.0625C7.99219 3.0625 7.05469 3.29688 6.1875 3.76562C5.32031 4.21094 4.59375 4.82031 4.00781 5.59375H7.45312C7.57031 5.59375 7.66406 5.64062 7.73438 5.73438C7.82812 5.80469 7.875 5.89844 7.875 6.01562V7.70312C7.875 7.82031 7.82812 7.92578 7.73438 8.01953C7.66406 8.08984 7.57031 8.125 7.45312 8.125Z"
                        fill="#D0D0D0"
                      />
                    </svg>
                    <div data-translation="reset" className="center-text">
                      Reset settings
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <a
              id="reset"
              className="accessibility-reset mobile-accessibly-d-none navigable"
              style={{ fontSize: 13, textDecoration: "none" }}
            >
              <svg
                className="option-svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.45312 8.125H0.421875C0.304688 8.125 0.199219 8.08984 0.105469 8.01953C0.0351562 7.92578 0 7.82031 0 7.70312V0.671875C0 0.390625 0.140625 0.25 0.421875 0.25H2.10938C2.39062 0.25 2.53125 0.390625 2.53125 0.671875V3.41406C3.35156 2.5 4.32422 1.79688 5.44922 1.30469C6.59766 0.789062 7.80469 0.53125 9.07031 0.53125C11.4844 0.554688 13.5352 1.42187 15.2227 3.13281C16.9102 4.82031 17.7422 6.87109 17.7188 9.28516C17.7188 11.6758 16.8633 13.7266 15.1523 15.4375C13.4648 17.125 11.4141 17.9688 9 17.9688C6.77344 17.9688 4.82812 17.2188 3.16406 15.7188C2.92969 15.5078 2.91797 15.2969 3.12891 15.0859L4.32422 13.8906C4.51172 13.7031 4.71094 13.7031 4.92188 13.8906C6.09375 14.9219 7.45312 15.4375 9 15.4375C10.7109 15.4375 12.1641 14.8398 13.3594 13.6445C14.5781 12.4258 15.1875 10.9609 15.1875 9.25C15.1875 7.53906 14.5781 6.08594 13.3594 4.89062C12.1641 3.67187 10.7109 3.0625 9 3.0625C7.99219 3.0625 7.05469 3.29688 6.1875 3.76562C5.32031 4.21094 4.59375 4.82031 4.00781 5.59375H7.45312C7.57031 5.59375 7.66406 5.64062 7.73438 5.73438C7.82812 5.80469 7.875 5.89844 7.875 6.01562V7.70312C7.875 7.82031 7.82812 7.92578 7.73438 8.01953C7.66406 8.08984 7.57031 8.125 7.45312 8.125Z"
                  fill="#D0D0D0"
                />
              </svg>
              <div data-translation="reset" className="center-text">
                Reset settings
              </div>
            </a>
            {props.shop.settings.showAccessiblyLogo && (
              <div className="accessibility-app-logo-container mobile-accessibly-d-none">
                <a
                  href="https://www.onthemapmarketing.com/accessibly/"
                  target="_blank"
                  title="On the Map Marketing"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 16,
                  }}
                  className="navigable"
                >
                  <div className="accessibility-app-logo">
                    {/* <AccessiblyLogo /> */}
                  </div>
                </a>
              </div>
            )}

            <h5
              className="accessibly-mobile-logo accessibly-mobile-visible"
              style={{ fontSize: 15 }}
            >
              Accesibly App by{" "}
              <a
                href="https://www.onthemapmarketing.com/accessibly/"
                aria-hidden="true"
                role="presentation"
                title="On the Map Marketing"
                className="otm-text navigable"
                target="_blank"
                style={{ fontSize: 15 }}
              >
                On The Map Marketing
              </a>
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
}
 export default Preview;
